module.exports = __webpack_public_path__ + "assets/final-bg.jpg";